import { Button, Text } from '@components/primitives';
import useFeatureFlag from '@customHooks/useFeatureFlag';
import { AntDesign } from '@expo/vector-icons';
import BottomSheet from '@molecules/LoginInfoSheet';
import { useNavigation } from '@react-navigation/native';
import {
  BOTTOMSHEET_CONTENT,
  BOTTONSHEET_KEYS,
  FEATURE_FLAGS,
  addBankTemplate1,
  addBankTemplate2,
  addBankTemplate3,
} from '@root/constants';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import { scale, verticalScale } from '@utils/normalize';
import { returnBottomSheetContent } from '@utils/utils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import bottomSheetHandlersForBankWithPin from './pinWithAddBankUtils';

export interface PinWithAddBankProps {
  type?: string;
  userBanks?: any[];
  fromTransfer?: boolean;
  source?: string;
}

const PinWithAddBank: React.FC<PinWithAddBankProps> = ({
  type = 'template1',
  userBanks = [],
  fromTransfer = false,
  source = '',
}) => {
  const navigation = useNavigation();
  const { t } = useTranslation('common');
  const { pinRegister } = getStore();

  const initialState = {
    visible: false,
    data: returnBottomSheetContent(BOTTONSHEET_KEYS.BANK_DELETE, BOTTOMSHEET_CONTENT[BOTTONSHEET_KEYS.BANK_DELETE]),
    errorCode: BOTTONSHEET_KEYS.BANK_DELETE,
  };

  const [infoModal, setInfoModal] = useState(initialState);
  const [isFeatureAvailale] = useFeatureFlag({ featureName: [FEATURE_FLAGS.SECURITY_PIN] });

  const { checkPinAndCreateBank, onPressPrimaryBottomSHeet, onPressSecondaryBottomSheet, onCloseModalHandler } =
    bottomSheetHandlersForBankWithPin({
      setInfoModal,
      infoModal,
      navigation,
      userBanks,
      initialState,
      isFeatureAvailale,
      pinRegister,
    });

  const renderButton = () => {
    const onPress = () => checkPinAndCreateBank(fromTransfer, source);
    switch (type) {
      case addBankTemplate1:
        return (
          <Text testID="btnAddBank" variant="sm-bold" color={colors.secondary.orchid} underline onPress={onPress}>
            {t('bankList.addBankAccount')}
          </Text>
        );
      case addBankTemplate2:
        return (
          <Button
            testID="btnAddBank"
            variant="ghost"
            onPress={onPress}
            borderColor={colors.disabled.smoke}
            marginY="16px"
            marginX="28px"
            rightIcon={<AntDesign name="plus" size={16} color="black" style={{ marginRight: scale(8) }} />}>
            <Text
              testID="btnAddBankTxt"
              variant="md-bold"
              style={{ marginHorizontal: scale(8), marginVertical: scale(8) }}>
              {t('profile.addBankString')}
            </Text>
          </Button>
        );
      case addBankTemplate3:
        return (
          <Button testID="btnAddBank" flex={1} onPress={onPress} paddingY={verticalScale(8)}>
            <Text testID="btnAddBankTxt" color={colors.neutral.cotton} variant="md-bold">
              {t('bankList.addBankAccount')}
            </Text>
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderButton()}
      <BottomSheet
        onPressPrimary={onPressPrimaryBottomSHeet}
        onPressSecondary={onPressSecondaryBottomSheet}
        loginInfo={infoModal}
        hasTwoButtons={infoModal.data.hasTwoButtons}
        onClose={onCloseModalHandler}
      />
    </>
  );
};

export default PinWithAddBank;
